import instance, { customConfig } from "../Utils/Interceptors/Interceptor";

const IndicadorCalculadoraService = async (values) => {
	try {
		return await instance.Backend.post("/Indicador/Calculadora", values, customConfig);
	} catch (error) {
		console.log(error);
	}
};

export { IndicadorCalculadoraService };
